import { ContentfulCallout } from '@jbhi-fi/apis/src/contentful/types';
import { Callout } from '@jbhi-fi/components/src/Callout/Callout';
import { CalloutTransformer } from '@jbhi-fi/components/src/Contentful/transformers/CalloutTransformer';
import { ContentAlert } from '@jbhi-fi/components/src/ContentAlert/ContentAlert';

export const determineCalloutTransformer = ({ fields }: ContentfulCallout) => {
  if (fields?.type === 'Standard')
    return {
      OutputComponent: Callout,
      transformer: CalloutTransformer.toCalloutProps,
    };

  return {
    OutputComponent: ContentAlert,
    transformer: CalloutTransformer.toAlertProps,
  };
};
